import { render } from "./AImage.vue?vue&type=template&id=43b33484&scoped=true"
import script from "./AImage.vue?vue&type=script&lang=js"
export * from "./AImage.vue?vue&type=script&lang=js"

import "./AImage.vue?vue&type=style&index=0&id=43b33484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b33484"]])

export default __exports__